import React from 'react'
import {CSSTransitionGroup} from 'react-transition-group';

const Quiz = (props) => (
    <div className="question-container">
        <div className="question">{props.question}
        </div>

        <div className="choices">

            <div
                key={"a"}
                data-letter="A"
                onClick={props.handleGuess}
                className={"choice-a " + (props.a.attempted
                ? " strike-through"
                : "")}>{props.a.text}</div>
            <div
                key={"b"}
                data-letter="B"
                onClick={props.handleGuess}
                className={"choice-b " + (props.b.attempted
                ? " strike-through"
                : "")}>{props.b.text}</div>
            <div
                key={"c"}
                data-letter="C"
                onClick={props.handleGuess}
                className={"choice-c " + (props.c.attempted
                ? " strike-through"
                : "")}>{props.c.text}</div>
            <div
                key={"d"}
                data-letter="D"
                onClick={props.handleGuess}
                className={"choice-d " + (props.d.attempted
                ? " strike-through"
                : "")}>{props.d.text}</div>

        </div>

        <div className="status"></div>
    </div>
)

export default Quiz

//    <div className="message">{props.message}</div>


// WEBPACK FOOTER //
// ./src/components/Quiz.js